<div class="modal-overlay" ></div>
<div class="modal-wrap">
  <div class="modal">

    @if(typeImage() === 'lastLesson'){
      <img src="assets/icons/lastLesson.jpg" alt="">
    } @else if (typeImage() === 'testNotFinished'){
      <img src="assets/icons/testNotFinished.jpg" alt="">
    } @else if (typeImage() === 'succsessAnketa') {
      <img src="assets/icons/success-test.svg" alt="">
    }

    <div class="wrap-textModal">
      <p class="din-pro-condensed  black-color text-modal " [style.min-height]="subTextModal() ? 'none': '52px' ">{{textModal()}}</p>
      @if(subTextModal()){
        <p class="din-pro-condensed black-color sub-text-modal">{{subTextModal()}}</p>
      }
    </div>
    <ng-content></ng-content>
  </div>
</div>
